import { stylesheet } from '@/features/ui/buttons/components/Button/styles'
import { ButtonProps } from '@/features/ui/buttons/components/Button/types'
import { ButtonStateEnum } from '@/features/ui/buttons/constants'
import { useEnabledButtonState } from '@/features/ui/buttons/hooks/useEnabledButtonState'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { Pressable } from 'react-native'
import { useStyles } from 'react-native-unistyles'

const Button: FC<ButtonProps> = ({
    children,
    disabled = false,
    type = 'primary',
    color = 'primary',
    size = 'big',
    FrontIcon,
    onPress,
    textStyle,
    style,
    testID,
}) => {
    const { state: enabledState, eventHandlers } = useEnabledButtonState()

    const { styles } = useStyles(stylesheet, { size })

    const state = disabled ? ButtonStateEnum.Disabled : enabledState

    return (
        <Pressable
            disabled={disabled}
            onPress={onPress}
            {...eventHandlers}
            style={[styles.container, styles.extraContainer(type, state, color), style]}
            testID={testID}
        >
            {FrontIcon && (
                <FrontIcon
                    fill="currentColor"
                    color={styles.extraIcon(type, state, color).color}
                    style={styles.icon}
                />
            )}
            <Typography.Button
                size={size}
                style={[styles.extraTypography(type, state, color), textStyle]}
            >
                {children}
            </Typography.Button>
        </Pressable>
    )
}

export default Button
